import { lazy } from 'react';
import { getCorrespondLabel } from '@/utils/global';
const OpenCourseRoutes = [
    {
        label: '',
        key: 'MainLayout',
        path: '/101/:businessId',
        element: lazy(() => import('@/components/Layout/OpenCourseLayout')),
        needJudgeRealName: true,
        realNameType: 'openCourse',
        children: [
            {
                label: getCorrespondLabel('101') + '首页',
                key: 'openCourse',
                path: 'home',
                show: true,
                element: lazy(() => import('@/page/openCourse/Home/index'))
            },
            {
                label: '公告',
                key: 'notice',
                show: true,
                path: 'notice',
                element: lazy(() => import('@/page/openCourse/Notice/Notice'))
            },
            {
                label: '成绩',
                key: 'score',
                show: true,
                path: 'score',
                element: lazy(() => import('@/page/Project/Score/Score'))
            },
            {
                label: '证书',
                key: 'certificate',
                show: true,
                path: 'certificate',
                element: lazy(() => import('@/page/Project/Certificate/Certificate'))
            },
            {
                label: '评论',
                key: 'comment',
                show: true,
                path: 'comment',
                element: lazy(() => import('@/page/Project/MyComment').then((module) => ({ default: () => <module.default template_id={101} /> })))
            }
        ]
    }
];
export default OpenCourseRoutes;
